import { useCallback, useEffect, useState } from 'react';
import { fetchEntitlements, fetchVolumes } from '../lib/hub-api';
import type { Entitlement, Volume } from '../types/hub';

export function useHubCatalog() {
  const [volumes, setVolumes] = useState<Volume[]>([]);
  const [entitlements, setEntitlements] = useState<Entitlement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true); setError('');
    try {
      const [nextVolumes, nextEntitlements] = await Promise.all([fetchVolumes(), fetchEntitlements()]);
      setVolumes(nextVolumes);
      setEntitlements(nextEntitlements);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Unable to load the hub.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { void refresh(); }, [refresh]);
  return { volumes, entitlements, loading, error, refresh };
}
